/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import FormOnEditPriority from "./FormOnEditPriority";
import TableOnPriority from "./TableOnPriority";

const ListPriority = (props) => {
	const BaseUrl = `${url.list_priority}`;
	const fetchData = useContext(FetchDataContext);
	const { getDataTables, updateData, tableRef } = fetchData;

	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [data, setData] = useState();

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
	};

	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		setData(params);
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_priority?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);
		return result;
	};

	return (
		<Grid direction="column" alignItems="center">
			<TableOnPriority
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
			/>
			<FormOnEditPriority
				fetchAPI={fetchAPI}
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
			/>
		</Grid>
	);
};
export default ListPriority;
